import { render, staticRenderFns } from "./ItemSemanaNomina.vue?vue&type=template&id=0d551cf4&"
import script from "./ItemSemanaNomina.vue?vue&type=script&lang=js&"
export * from "./ItemSemanaNomina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports